export const environment = {
  production: true,
    API_URL: 'https://back.crediforza.corefluens.co/api/',
    enterprise: "crediforza",
    api_username: 'crediforza',
    api_password: 'D460RRuUhNAb',
    enable_seas: true,
};
